/* Rework Ltd — bilingual site content (EN / TH).
   Static copy for every non-Directus section. Directus-backed services /
   products / articles fall back to the arrays here (see lib/content.js). */

const contactEmail = "contact@rework.ltd";
const contactPhone = "+66 2 0141965";
const contactPhoneHref = "tel:+6620141965";
const contactAddress = "89/31 หมู่บ้าน เดอะ พาลาซเซตโต้ คลองหลวง หมู่ที่ 6 ตำบลคลองสาม อำเภอคลองหลวง จ.ปทุมธานี 12120";
const contactMapHref = "https://www.google.co.th/maps/search/89%2F31+%E0%B8%AB%E0%B8%A1%E0%B8%B9%E0%B9%88%E0%B8%9A%E0%B9%89%E0%B8%B2%E0%B8%99+%E0%B9%80%E0%B8%94%E0%B8%AD%E0%B8%B0+%E0%B8%9E%E0%B8%B2%E0%B8%A5%E0%B8%B2%E0%B8%8B%E0%B9%80%E0%B8%8B%E0%B8%95%E0%B9%82%E0%B8%95%E0%B9%89+%E0%B8%84%E0%B8%A5%E0%B8%AD%E0%B8%87%E0%B8%AB%E0%B8%A5%E0%B8%A7%E0%B8%87+%E0%B8%AB%E0%B8%A1%E0%B8%B9%E0%B9%88%E0%B8%97%E0%B8%B5%E0%B9%88+6+%E0%B8%84%E0%B8%A5%E0%B8%AD%E0%B8%87%E0%B8%AA%E0%B8%B2%E0%B8%A1+%E0%B8%84%E0%B8%A5%E0%B8%AD%E0%B8%87%E0%B8%AB%E0%B8%A5%E0%B8%A7%E0%B8%87+%E0%B8%9B%E0%B8%97%E0%B8%B8%E0%B8%A1%E0%B8%98%E0%B8%B2%E0%B8%99%E0%B8%B5+%7C+%28%E0%B8%9A%E0%B8%A3%E0%B8%B4%E0%B8%A9%E0%B8%B1%E0%B8%97+%E0%B8%A3%E0%B8%B5%E0%B9%80%E0%B8%A7%E0%B8%B4%E0%B8%A3%E0%B9%8C%E0%B8%84+%E0%B8%88%E0%B8%B3%E0%B8%81%E0%B8%B1%E0%B8%94%29";

export const siteContent = {
  en: {
    dir: "ltr",
    fallbackIntro: "This page is preserved from the previous Rework site while content is migrated into the CMS.",
    notFoundTitle: "We couldn't find that page.",
    notFoundText: "The link may be old or mistyped. Head back home, or tell us what you were looking for.",
    nav: {
      links: [
        { id: "home", label: "Home" },
        { id: "services", label: "Services" },
        { id: "products", label: "Products" },
        { id: "articles", label: "Articles" },
        { id: "careers", label: "Careers" }
      ],
      contact: "Contact us",
      getStarted: "Get started",
      localeName: "EN"
    },
    home: {
      eyebrow: "AI · Digital solutions",
      titleA: "AI solutions for",
      titleB: "real customer pain.",
      lede: "We design AI-driven digital solutions that target your customers' real pain points — from first idea to shipped product, under one accountable roof.",
      ctaPrimary: "Get started",
      ctaSecondary: "Explore products",
      statsEyebrow: "By the numbers",
      statsTitle: "Proof, not promises.",
      stats: [
        { value: "120+", label: "Digital products shipped", sub: "Web, mobile & internal tools", icon: "rocket" },
        { value: "40%", label: "Average efficiency gained", sub: "Across client operations", icon: "trending-up" },
        { value: "99.9%", label: "Platform uptime", sub: "Monitored around the clock", icon: "activity" },
        { value: "4.9/5", label: "Client satisfaction", sub: "From long-term partners", icon: "star" },
        { value: "12+", label: "Years engineering", sub: "A senior, accountable team", icon: "award" },
        { value: "24/7", label: "Support & monitoring", sub: "Real people, fast response", icon: "headset" }
      ],
      servicesEyebrow: "What we do",
      servicesTitle: "Four disciplines, one accountable team.",
      servicesLede: "From the device on the vehicle to the software in your hand — we design, integrate and operate the whole stack.",
      productsEyebrow: "Built by Rework",
      productsTitle: "A GPS & telematics platform for real fleets.",
      productsLede: "Track vehicles, devices, routes and operating status with tools designed for logistics and delivery teams.",
      productsCta: "See all products",
      whyEyebrow: "Why Rework",
      whyTitle: "Refine. Reinvent. Rework.",
      whyLede: "We take the systems you already run and make them faster, clearer and more connected — without the agency theatre.",
      values: [
        { icon: "radar", title: "Operations-first", body: "We design from the depot and the route, not the slide deck. Software that survives a real workday." },
        { icon: "plug", title: "One integrated stack", body: "Devices, platform, integrations and support from a single team — no finger-pointing between vendors." },
        { icon: "languages", title: "Bilingual by default", body: "English and Thai delivery, documentation and support for teams that work across both." },
        { icon: "trending-up", title: "Built to scale", body: "From a handful of vehicles to a national fleet on the same platform — you grow, it keeps up." }
      ],
      articlesEyebrow: "From the team",
      articlesTitle: "Notes on connected operations.",
      articlesCta: "Read all articles",
      ctaTitle: "Let's connect your operation.",
      ctaLede: "Tell us what you run today. We'll show you what a connected version looks like.",
      ctaButton: "Book a consultation",
      heroProof: "From first idea to shipped product — designed, built and supported in-house.",
      trustEyebrow: "Trusted by teams",
      trustLabel: "Product, operations and growth teams partner with Rework to ship digital solutions that actually work.",
      trustSectors: ["Software & product", "Operations", "Retail & commerce", "Field services", "Logistics"],
      partnersLabel: "Official partner of",
      partners: [
        { name: "Verpex", kind: "Hosting infrastructure" },
        { name: "GoDaddy", kind: "Domains & web services" },
        { name: "Framer", kind: "Web design platform" }
      ],
      caseStat: "40%",
      caseStatLabel: "fewer manual hours",
      caseQuote: "Rework replaced a tangle of spreadsheets and manual steps with one platform our team actually wants to use.",
      caseAttr: "Operations lead · multi-site retailer"
    },
    servicesPage: {
      eyebrow: "Services",
      title: "From the device to the dashboard.",
      lede: "Four disciplines that connect your operation end to end. Engaged together or one at a time.",
      detail: [
        {
          icon: "layers",
          title: "Digital transformation & system integrator",
          category: "Transformation",
          body: "Unlock your business's potential with comprehensive digital transformation — turnkey software solutions that propel your organization into the future.",
          points: ["Turnkey software solutions", "System integration", "Legacy modernization", "Cloud & infrastructure"]
        },
        {
          icon: "palette",
          title: "Customer experience design & branding",
          category: "Experience & brand",
          body: "Enhance customer satisfaction and loyalty through a customer-centric approach — service optimization, intuitive UX design and effective CRM strategies.",
          points: ["UX / UI design", "Brand & identity", "Service optimization", "CRM strategy"]
        },
        {
          icon: "smartphone",
          title: "Mobile / web app development & marketing",
          category: "Apps & marketing",
          body: "Harness mobile and web technologies with our expert team — innovative, user-friendly applications tailored to your unique requirements.",
          points: ["Mobile apps (iOS / Android)", "Web applications", "Digital marketing", "SEO & growth"]
        },
        {
          icon: "radio-tower",
          title: "IoT & location-based platforms",
          category: "Connected platforms",
          body: "Embrace IoT and location-based technologies with our robust software platform — connected, intelligent solutions for your business needs.",
          points: ["IoT platform", "GPS & location services", "Connected devices", "Real-time data"]
        }
      ],
      ctaTitle: "Not sure where to start?",
      ctaLede: "Bring us the messiest part of your operation. We'll map the fastest path to connected.",
      ctaButton: "Talk to an engineer"
    },
    productsPage: {
      eyebrow: "Products",
      title: "GPS & telematics, ready for the road.",
      lede: "A platform and product family built for logistics, delivery and managed-fleet teams.",
      filters: ["All", "Fleet visibility", "Delivery operations", "Asset control", "Specialized tracking", "Partner growth", "Commercial options"],
      learnMore: "Learn more",
      results: "products",
      empty: "No products in this category yet — tell us what you need.",
      featuredLabel: "Featured",
      featuredCta: "Request a demo",
      featuredPoints: ["Live vehicle & asset tracking", "Routes, geofences & alerts", "Reports your team will actually open"],
      ctaTitle: "Want a guided demo?",
      ctaLede: "See the tracking platform on your own routes and vehicles.",
      ctaButton: "Request a demo"
    },
    articlesPage: {
      eyebrow: "Articles",
      title: "Notes on connected operations.",
      lede: "Field-tested thinking on telematics, logistics software and running a connected fleet.",
      readMore: "Read article",
      close: "Close",
      readerNote: "This is a preview. Want the full playbook?",
      talk: "Talk to us",
      items: [
        { tag: "Telematics", title: "What a telematics rollout actually looks like", excerpt: "The unglamorous steps between buying a device and trusting the data it sends back.", date: "May 2026", read: "6 min", body: ["A telematics rollout is less about the hardware and more about trust. The device is easy; getting your team to believe the numbers it sends back is the real work.", "Start small — one route, one depot, one metric that matters. Prove the data is right, then expand. Skip that step and you end up with dashboards nobody opens."] },
        { tag: "Logistics", title: "Proof of delivery without the paperwork", excerpt: "How delivery teams cut disputes by capturing the right signal at the right moment.", date: "Apr 2026", read: "5 min", body: ["Most delivery disputes come down to a missing signal at the right moment — a photo, a timestamp, a signature. Capture it automatically and the argument disappears.", "The goal isn't more paperwork; it's less. Replace the clipboard with one confirmation step a driver can finish in seconds."] },
        { tag: "Fleet", title: "The metrics that actually predict downtime", excerpt: "Most fleet dashboards measure the wrong things. Here's the short list that matters.", date: "Apr 2026", read: "7 min", body: ["Most fleet dashboards measure what's easy to count, not what predicts failure. Utilization and idle patterns tell you more about coming downtime than raw mileage.", "Pick three leading indicators, watch the trend, and act before the breakdown — not after the tow truck."] },
        { tag: "Software", title: "Buy, build, or integrate?", excerpt: "A practical way to decide when custom software earns its keep over off-the-shelf tools.", date: "Mar 2026", read: "8 min", body: ["Custom software earns its keep when the workflow is your edge. If it's a solved problem, buy it; if it's the glue between systems, integrate it.", "The expensive mistake is building what you could have bought — or buying a tool that never fits how you actually work."] },
        { tag: "IoT", title: "Choosing devices that survive the depot", excerpt: "Ruggedization, connectivity and power — what to check before you commit to hardware.", date: "Mar 2026", read: "5 min", body: ["Field hardware lives a hard life — heat, dust, power spikes and rough handling. Ruggedization and connectivity matter more than spec-sheet features.", "Test in the depot before you commit at scale. A device that fails in month three costs far more than its unit price."] },
        { tag: "Growth", title: "SEO for businesses that sell to operations", excerpt: "Ranking when your buyers search in two languages and three acronyms.", date: "Feb 2026", read: "6 min", body: ["Ranking is harder when your buyers search in two languages and three acronyms. Structure content around the problems they describe, not the products you sell.", "Bilingual SEO isn't translation — it's meeting each audience in the words they actually type."] }
      ]
    },
    careersPage: {
      eyebrow: "Careers",
      title: "Build systems that move the real world.",
      lede: "We're a small team in Thailand shipping connected products for Digital solutions, logistic, telematics, IoT, hands-on, low on ceremony.",
      perksTitle: "How we work",
      perks: [
        { icon: "users", title: "Senior, small teams", body: "You'll own real surface area from week one — no layers of hand-off." },
        { icon: "globe", title: "Bilingual & cross-border", body: "We deliver in English and Thai, for clients on both sides of the map." },
        { icon: "wrench", title: "Whole-stack work", body: "Device to dashboard. You won't be boxed into one thin layer." },
        { icon: "heart-handshake", title: "Real accountability", body: "We ship to operations that can't go down. The work matters and we treat it that way." }
      ],
      openEyebrow: "Open roles",
      roles: [
        { title: "Senior Full-stack Engineer", team: "Software", type: "Full-time · Bangkok / Remote" },
        { title: "Telematics / IoT Engineer", team: "Connected systems", type: "Full-time · Bangkok" },
        { title: "Product Designer", team: "Product", type: "Full-time · Bangkok / Remote" },
        { title: "Solutions Consultant (EN/TH)", team: "Delivery", type: "Full-time · Bangkok" }
      ],
      apply: "Apply",
      ctaTitle: "Don't see your role?",
      ctaLede: "If you build things that have to work in the field, we want to hear from you.",
      ctaButton: "Send an intro"
    },
    contactPage: {
      eyebrow: "Contact us",
      title: "Tell us what you run.",
      lede: "Send us the shape of your operation and we'll come back with a connected version — usually within a business day.",
      infoTitle: "Reach us directly",
      info: [
        { icon: "mail", label: "Email", value: contactEmail, href: `mailto:${contactEmail}` },
        { icon: "phone", label: "Phone", value: contactPhone, href: contactPhoneHref },
        { icon: "map-pin", label: "Office", value: contactAddress, href: contactMapHref, external: true }
      ],
      form: {
        name: "Name",
        email: "Work email",
        company: "Company",
        interest: "What do you need?",
        interestOptions: ["GPS & telematics", "IoT integration", "Custom software", "IT & system integration", "Website / SEO", "Something else"],
        message: "Tell us about your operation",
        submit: "Send message",
        sending: "Sending…",
        success: "Thanks — we'll be in touch within a business day.",
        errName: "Please enter your name.",
        errEmail: "Enter a valid email address.",
        errMessage: "A sentence or two is plenty."
      }
    },
    footer: {
      tagline: "Refine. Reinvent. Rework.",
      blurb: "Connected operations for logistics, delivery and field teams. IoT, telematics and custom software — built and supported in-house.",
      cols: [
        { title: "Services", links: ["IoT & telematics", "Software development", "IT & integration", "Website & SEO"] },
        { title: "Products", links: ["GPS tracking", "Delivery tracking", "Vehicle leasing", "Partner program"] },
        { title: "Company", links: ["Articles", "Careers", "Contact us"] }
      ],
      rights: "© 2026 Rework Ltd. All rights reserved.",
      partnerLine: "Official partner of Verpex, GoDaddy & Framer."
    },
    services: [
      { icon: "layers", title: "Digital transformation & system integration", body: "Turnkey software solutions that propel your organization into the future.", gain: "Fewer disconnected tools" },
      { icon: "palette", title: "Customer experience design & branding", body: "Customer-centric UX, service optimization and CRM that build loyalty.", gain: "Higher retention" },
      { icon: "smartphone", title: "Mobile / web app development & marketing", body: "Innovative, user-friendly apps tailored to your unique requirements.", gain: "Faster time to launch" },
      { icon: "radio-tower", title: "IoT & location-based platforms", body: "Connected, intelligent solutions powered by IoT and location tech.", gain: "Real-time visibility" }
    ],
    products: [
      { title: "GPS tracking platform", category: "Fleet visibility", description: "Track vehicles, devices, routes and operating status with a platform designed for logistics teams.", icon: "satellite" },
      { title: "Logistics & delivery tracking", category: "Delivery operations", description: "Coordinate delivery workflows, route updates, proof-of-delivery and customer visibility.", icon: "truck" },
      { title: "Vehicle leasing control", category: "Asset control", description: "Manage vehicle usage, monitoring and business rules for leasing and managed fleets.", icon: "key-round" },
      { title: "Personal, pet & agriculture tracking", category: "Specialized tracking", description: "Adapt GPS and IoT products for people, pets, agricultural assets and field environments.", icon: "map-pinned" },
      { title: "GPS partner program", category: "Partner growth", description: "Launch new revenue streams with Rework GPS technology, training and partner support.", icon: "handshake" },
      { title: "Pricing & packages", category: "Commercial options", description: "Review package direction and implementation paths for GPS and telematics products.", icon: "tag" }
    ]
  },

  th: {
    dir: "ltr",
    fallbackIntro: "หน้านี้ถูกเก็บไว้จากเว็บไซต์ Rework เดิม ระหว่างการย้ายเนื้อหาเข้าสู่ระบบ CMS",
    notFoundTitle: "ไม่พบหน้าที่คุณกำลังหา",
    notFoundText: "ลิงก์อาจเก่าหรือพิมพ์ผิด กลับไปหน้าแรก หรือบอกเราว่าคุณกำลังมองหาอะไร",
    nav: {
      links: [
        { id: "home", label: "หน้าแรก" },
        { id: "services", label: "บริการ" },
        { id: "products", label: "ผลิตภัณฑ์" },
        { id: "articles", label: "บทความ" },
        { id: "careers", label: "ร่วมงาน" }
      ],
      contact: "ติดต่อเรา",
      getStarted: "เริ่มต้นใช้งาน",
      localeName: "TH"
    },
    home: {
      eyebrow: "AI · โซลูชันดิจิทัล",
      titleA: "โซลูชัน AI สำหรับ",
      titleB: "ปัญหาลูกค้าที่แท้จริง",
      lede: "เราออกแบบโซลูชันดิจิทัลที่ขับเคลื่อนด้วย AI เพื่อแก้ปัญหาที่แท้จริงของลูกค้า — ตั้งแต่ไอเดียแรกจนถึงการส่งมอบ ดูแลครบในทีมเดียว",
      ctaPrimary: "เริ่มต้นใช้งาน",
      ctaSecondary: "ดูผลิตภัณฑ์",
      statsEyebrow: "ตัวเลขที่พิสูจน์ได้",
      statsTitle: "พิสูจน์ด้วยผลงาน ไม่ใช่คำสัญญา",
      stats: [
        { value: "120+", label: "ดิจิทัลโปรดักต์ที่ส่งมอบ", sub: "เว็บ แอป และเครื่องมือภายใน", icon: "rocket" },
        { value: "40%", label: "ประสิทธิภาพที่เพิ่มขึ้นโดยเฉลี่ย", sub: "จากงานของลูกค้า", icon: "trending-up" },
        { value: "99.9%", label: "เสถียรภาพของระบบ", sub: "เฝ้าระวังตลอด 24/7", icon: "activity" },
        { value: "4.9/5", label: "ความพึงพอใจของลูกค้า", sub: "จากพาร์ทเนอร์ระยะยาว", icon: "star" },
        { value: "12+", label: "ปีของประสบการณ์", sub: "ทีมที่รับผิดชอบจริง", icon: "award" },
        { value: "24/7", label: "ดูแลและเฝ้าระวัง", sub: "ทีมจริง ตอบไว", icon: "headset" }
      ],
      servicesEyebrow: "สิ่งที่เราทำ",
      servicesTitle: "สี่งาน หนึ่งทีมที่รับผิดชอบ",
      servicesLede: "ตั้งแต่อุปกรณ์บนรถ จนถึงซอฟต์แวร์ในมือคุณ — เราออกแบบ เชื่อมต่อ และดูแลทั้งระบบ",
      productsEyebrow: "สร้างโดย Rework",
      productsTitle: "แพลตฟอร์ม GPS & Telematics สำหรับงานจริง",
      productsLede: "ติดตามรถ อุปกรณ์ เส้นทาง และสถานะงานด้วยเครื่องมือที่ออกแบบมาเพื่อทีมโลจิสติกส์และการจัดส่ง",
      productsCta: "ดูผลิตภัณฑ์ทั้งหมด",
      whyEyebrow: "ทำไมต้อง Rework",
      whyTitle: "Refine. Reinvent. Rework.",
      whyLede: "เรานำระบบที่คุณใช้อยู่มาทำให้เร็วขึ้น ชัดขึ้น และเชื่อมต่อกันมากขึ้น — โดยไม่ต้องมีพิธีรีตองแบบเอเจนซี",
      values: [
        { icon: "radar", title: "เริ่มจากหน้างานจริง", body: "เราออกแบบจากคลังและเส้นทาง ไม่ใช่จากสไลด์ ซอฟต์แวร์ที่ใช้ได้จริงทั้งวันทำงาน" },
        { icon: "plug", title: "ระบบเดียวที่ครบ", body: "อุปกรณ์ แพลตฟอร์ม การเชื่อมต่อ และซัพพอร์ตจากทีมเดียว ไม่ต้องโยนกันไปมา" },
        { icon: "languages", title: "สองภาษาเป็นค่าเริ่มต้น", body: "ส่งมอบ เอกสาร และซัพพอร์ตทั้งภาษาอังกฤษและไทยสำหรับทีมที่ทำงานทั้งสองฝั่ง" },
        { icon: "trending-up", title: "พร้อมขยายตัว", body: "ตั้งแต่รถไม่กี่คันไปจนถึง fleet ระดับประเทศบนแพลตฟอร์มเดียว คุณโต ระบบก็ตามทัน" }
      ],
      articlesEyebrow: "จากทีมงาน",
      articlesTitle: "บันทึกเรื่องระบบที่เชื่อมต่อ",
      articlesCta: "อ่านบทความทั้งหมด",
      ctaTitle: "มาเชื่อมต่อระบบของคุณกัน",
      ctaLede: "บอกเราว่าวันนี้คุณดูแลอะไรอยู่ แล้วเราจะให้เห็นเวอร์ชันที่เชื่อมต่อกัน",
      ctaButton: "นัดปรึกษา",
      heroProof: "ตั้งแต่ไอเดียแรกจนถึงการส่งมอบ — ออกแบบ พัฒนา และดูแลด้วยทีมของเราเอง",
      trustEyebrow: "ได้รับความไว้วางใจ",
      trustLabel: "ทีมโปรดักต์ ทีมปฏิบัติการ และทีมการเติบโต เลือก Rework เพื่อส่งมอบโซลูชันดิจิทัลที่ใช้งานได้จริง",
      trustSectors: ["ซอฟต์แวร์ & โปรดักต์", "ปฏิบัติการ", "ค้าปลีก", "งานภาคสนาม", "โลจิสติกส์"],
      partnersLabel: "พาร์ทเนอร์อย่างเป็นทางการของ",
      partners: [
        { name: "Verpex", kind: "โครงสร้างโฮสติ้ง" },
        { name: "GoDaddy", kind: "โดเมน & เว็บเซอร์วิส" },
        { name: "Framer", kind: "แพลตฟอร์มออกแบบเว็บ" }
      ],
      caseStat: "40%",
      caseStatLabel: "ลดงานแมนนวล",
      caseQuote: "Rework เปลี่ยนสเปรดชีตและงานแมนนวลที่ยุ่งเหยิงให้เป็นแพลตฟอร์มเดียวที่ทีมอยากใช้จริง",
      caseAttr: "หัวหน้าฝ่ายปฏิบัติการ · ผู้ค้าปลีกหลายสาขา"
    },
    servicesPage: {
      eyebrow: "บริการ",
      title: "ตั้งแต่อุปกรณ์ จนถึงแดชบอร์ด",
      lede: "สี่งานที่เชื่อมระบบของคุณตั้งแต่ต้นจนจบ เลือกใช้รวมกันหรือทีละอย่างก็ได้",
      detail: [
        { icon: "layers", title: "Digital Transformation & System Integrator", category: "Transformation", body: "ปลดล็อกศักยภาพธุรกิจด้วยบริการ Digital Transformation ครบวงจร — โซลูชันซอฟต์แวร์แบบ turnkey ที่พาองค์กรของคุณก้าวสู่อนาคต", points: ["โซลูชันซอฟต์แวร์ turnkey", "เชื่อมต่อระบบ (System Integration)", "ปรับปรุงระบบเดิมให้ทันสมัย", "คลาวด์และโครงสร้างพื้นฐาน"] },
        { icon: "palette", title: "Customer Experience Design & Branding", category: "Experience & brand", body: "ยกระดับความพึงพอใจและความภักดีของลูกค้าด้วยแนวคิดที่ยึดลูกค้าเป็นศูนย์กลาง — การบริการ การออกแบบ UX และกลยุทธ์ CRM", points: ["ออกแบบ UX / UI", "แบรนด์และอัตลักษณ์", "ปรับปรุงงานบริการลูกค้า", "กลยุทธ์ CRM"] },
        { icon: "smartphone", title: "Mobile / Web App Development & Marketing", category: "Apps & marketing", body: "ใช้พลังของเทคโนโลยีมือถือและเว็บกับทีมผู้เชี่ยวชาญของเรา — แอปพลิเคชันที่สร้างสรรค์และใช้งานง่าย ปรับให้ตรงกับความต้องการของคุณ", points: ["แอปมือถือ (iOS / Android)", "เว็บแอปพลิเคชัน", "การตลาดดิจิทัล", "SEO และการเติบโต"] },
        { icon: "radio-tower", title: "IoT & Location-Based Platforms", category: "Connected platforms", body: "นำ IoT และเทคโนโลยีระบุตำแหน่งมาใช้ด้วยแพลตฟอร์มซอฟต์แวร์ที่แข็งแกร่ง — โซลูชันที่เชื่อมต่อและชาญฉลาดสำหรับธุรกิจของคุณ", points: ["แพลตฟอร์ม IoT", "GPS และบริการระบุตำแหน่ง", "อุปกรณ์ที่เชื่อมต่อ", "ข้อมูลแบบเรียลไทม์"] }
      ],
      ctaTitle: "ไม่แน่ใจว่าจะเริ่มตรงไหน?",
      ctaLede: "เอาส่วนที่ยุ่งที่สุดของงานคุณมา แล้วเราจะวางเส้นทางที่เร็วที่สุดสู่ระบบที่เชื่อมต่อ",
      ctaButton: "คุยกับวิศวกร"
    },
    productsPage: {
      eyebrow: "ผลิตภัณฑ์",
      title: "GPS & Telematics พร้อมลงถนน",
      lede: "แพลตฟอร์มและตระกูลผลิตภัณฑ์ที่สร้างมาเพื่อทีมโลจิสติกส์ การจัดส่ง และการบริหาร fleet",
      filters: ["ทั้งหมด", "Fleet visibility", "Delivery operations", "Asset control", "Specialized tracking", "Partner growth", "Commercial options"],
      learnMore: "ดูเพิ่มเติม",
      results: "ผลิตภัณฑ์",
      empty: "ยังไม่มีผลิตภัณฑ์ในหมวดนี้ — บอกเราว่าคุณต้องการอะไร",
      featuredLabel: "แนะนำ",
      featuredCta: "ขอเดโม",
      featuredPoints: ["ติดตามรถและทรัพย์สินแบบเรียลไทม์", "เส้นทาง geofence และการแจ้งเตือน", "รายงานที่ทีมเปิดดูจริง"],
      ctaTitle: "อยากดูเดโมแบบมีไกด์?",
      ctaLede: "ดูแพลตฟอร์มติดตามบนเส้นทางและรถของคุณเอง",
      ctaButton: "ขอเดโม"
    },
    articlesPage: {
      eyebrow: "บทความ",
      title: "บันทึกเรื่องระบบที่เชื่อมต่อ",
      lede: "แนวคิดที่ผ่านการใช้งานจริงเรื่อง Telematics ซอฟต์แวร์โลจิสติกส์ และการดูแล fleet ที่เชื่อมต่อ",
      readMore: "อ่านบทความ",
      close: "ปิด",
      readerNote: "นี่คือตัวอย่าง อยากได้ฉบับเต็มไหม?",
      talk: "คุยกับเรา",
      items: [
        { tag: "Telematics", title: "การติดตั้ง Telematics จริง ๆ เป็นอย่างไร", excerpt: "ขั้นตอนที่ไม่หวือหวาระหว่างการซื้ออุปกรณ์กับการเชื่อใจข้อมูลที่มันส่งกลับมา", date: "พ.ค. 2026", read: "6 นาที", body: ["การติดตั้ง Telematics ไม่ได้อยู่ที่ฮาร์ดแวร์ แต่อยู่ที่ความเชื่อใจ เริ่มจากเส้นทางเดียว คลังเดียว และตัวเลขเดียวที่สำคัญ พิสูจน์ว่าข้อมูลถูกต้องก่อน แล้วค่อยขยาย"] },
        { tag: "Logistics", title: "หลักฐานการส่งโดยไม่ต้องใช้กระดาษ", excerpt: "ทีมจัดส่งลดข้อพิพาทได้อย่างไรด้วยการเก็บสัญญาณที่ถูกต้องในจังหวะที่ใช่", date: "เม.ย. 2026", read: "5 นาที", body: ["ข้อพิพาทการจัดส่งส่วนใหญ่เกิดจากสัญญาณที่หายไปในจังหวะที่ใช่ — รูป เวลา หรือลายเซ็น เก็บมันอัตโนมัติแล้วข้อโต้แย้งก็หายไป โดยไม่ต้องเพิ่มงานเอกสาร"] },
        { tag: "Fleet", title: "ตัวเลขที่ทำนายการหยุดทำงานได้จริง", excerpt: "แดชบอร์ด fleet ส่วนใหญ่วัดผิดจุด นี่คือรายการสั้น ๆ ที่สำคัญ", date: "เม.ย. 2026", read: "7 นาที", body: ["แดชบอร์ด fleet ส่วนใหญ่วัดสิ่งที่นับง่าย ไม่ใช่สิ่งที่ทำนายการเสีย เลือกตัวชี้วัดนำสัก 3 ตัว ดูแนวโน้ม แล้วลงมือก่อนรถจะจอด"] },
        { tag: "Software", title: "ซื้อ สร้าง หรือเชื่อมต่อ?", excerpt: "วิธีตัดสินใจอย่างเป็นรูปธรรมว่าเมื่อไหร่ซอฟต์แวร์ที่สั่งทำคุ้มกว่าของสำเร็จรูป", date: "มี.ค. 2026", read: "8 นาที", body: ["ซอฟต์แวร์สั่งทำคุ้มค่าเมื่อ workflow คือจุดแข็งของคุณ ถ้าเป็นปัญหาที่แก้แล้วก็ซื้อ ถ้าเป็นการเชื่อมระบบก็อินทิเกรต อย่าสร้างสิ่งที่ซื้อได้"] },
        { tag: "IoT", title: "เลือกอุปกรณ์ที่ทนงานคลังได้", excerpt: "ความทนทาน การเชื่อมต่อ และพลังงาน — สิ่งที่ต้องเช็กก่อนตัดสินใจซื้อฮาร์ดแวร์", date: "มี.ค. 2026", read: "5 นาที", body: ["ฮาร์ดแวร์ภาคสนามเจอทั้งความร้อน ฝุ่น และไฟกระชาก ความทนทานและการเชื่อมต่อสำคัญกว่าสเปกบนกระดาษ ทดสอบในคลังจริงก่อนขยายใหญ่"] },
        { tag: "Growth", title: "SEO สำหรับธุรกิจที่ขายให้งานปฏิบัติการ", excerpt: "การติดอันดับเมื่อผู้ซื้อค้นหาด้วยสองภาษาและสามตัวย่อ", date: "ก.พ. 2026", read: "6 นาที", body: ["การติดอันดับยากขึ้นเมื่อผู้ซื้อค้นหาด้วยสองภาษาและสามตัวย่อ จัดคอนเทนต์รอบปัญหาที่พวกเขาพูด ไม่ใช่ผลิตภัณฑ์ที่คุณขาย"] }
      ]
    },
    careersPage: {
      eyebrow: "ร่วมงาน",
      title: "สร้างระบบที่ขับเคลื่อนโลกจริง",
      lede: "เราเป็นทีมเล็กที่มากประสบการณ์ในไทย ส่งมอบผลิตภัณฑ์เชื่อมต่อสำหรับโลจิสติกส์และงานภาคสนาม สองภาษา ลงมือทำจริง ไม่มีพิธีรีตอง",
      perksTitle: "เราทำงานกันอย่างไร",
      perks: [
        { icon: "users", title: "ทีมเล็ก มากประสบการณ์", body: "คุณได้รับผิดชอบงานจริงตั้งแต่สัปดาห์แรก ไม่มีการส่งต่อหลายชั้น" },
        { icon: "globe", title: "สองภาษา ข้ามพรมแดน", body: "เราส่งมอบทั้งภาษาอังกฤษและไทย ให้ลูกค้าทั้งสองฝั่งของแผนที่" },
        { icon: "wrench", title: "ทำงานทั้งระบบ", body: "ตั้งแต่อุปกรณ์ถึงแดชบอร์ด คุณจะไม่ถูกจำกัดอยู่แค่ชั้นเดียว" },
        { icon: "heart-handshake", title: "รับผิดชอบจริง", body: "เราส่งมอบให้งานที่หยุดไม่ได้ งานนี้สำคัญ และเราดูแลมันแบบนั้น" }
      ],
      openEyebrow: "ตำแหน่งที่เปิดรับ",
      roles: [
        { title: "Senior Full-stack Engineer", team: "Software", type: "เต็มเวลา · กรุงเทพฯ / รีโมท" },
        { title: "Telematics / IoT Engineer", team: "Connected systems", type: "เต็มเวลา · กรุงเทพฯ" },
        { title: "Product Designer", team: "Product", type: "เต็มเวลา · กรุงเทพฯ / รีโมท" },
        { title: "Solutions Consultant (EN/TH)", team: "Delivery", type: "เต็มเวลา · กรุงเทพฯ" }
      ],
      apply: "สมัคร",
      ctaTitle: "ไม่เห็นตำแหน่งของคุณ?",
      ctaLede: "ถ้าคุณสร้างสิ่งที่ต้องใช้งานได้จริงในสนาม เราอยากได้ยินจากคุณ",
      ctaButton: "ส่งแนะนำตัว"
    },
    contactPage: {
      eyebrow: "ติดต่อเรา",
      title: "บอกเราว่าคุณดูแลอะไรอยู่",
      lede: "ส่งภาพรวมของงานคุณมา แล้วเราจะกลับไปพร้อมเวอร์ชันที่เชื่อมต่อ — ปกติภายในหนึ่งวันทำการ",
      infoTitle: "ติดต่อเราโดยตรง",
      info: [
        { icon: "mail", label: "อีเมล", value: contactEmail, href: `mailto:${contactEmail}` },
        { icon: "phone", label: "โทรศัพท์", value: contactPhone, href: contactPhoneHref },
        { icon: "map-pin", label: "ออฟฟิศ", value: contactAddress, href: contactMapHref, external: true }
      ],
      form: {
        name: "ชื่อ",
        email: "อีเมลที่ทำงาน",
        company: "บริษัท",
        interest: "คุณต้องการอะไร?",
        interestOptions: ["GPS & Telematics", "เชื่อมต่อ IoT", "ซอฟต์แวร์สั่งทำ", "IT & System Integration", "เว็บไซต์ / SEO", "อื่น ๆ"],
        message: "เล่าเรื่องงานของคุณให้เราฟัง",
        submit: "ส่งข้อความ",
        sending: "กำลังส่ง…",
        success: "ขอบคุณ — เราจะติดต่อกลับภายในหนึ่งวันทำการ",
        errName: "กรุณากรอกชื่อของคุณ",
        errEmail: "กรุณากรอกอีเมลที่ถูกต้อง",
        errMessage: "หนึ่งหรือสองประโยคก็พอแล้ว"
      }
    },
    footer: {
      tagline: "Refine. Reinvent. Rework.",
      blurb: "ระบบที่เชื่อมต่อสำหรับโลจิสติกส์ การจัดส่ง และทีมภาคสนาม IoT, Telematics และซอฟต์แวร์สั่งทำ — สร้างและดูแลด้วยทีมของเราเอง",
      cols: [
        { title: "บริการ", links: ["IoT & Telematics", "พัฒนาซอฟต์แวร์", "IT & Integration", "เว็บไซต์ & SEO"] },
        { title: "ผลิตภัณฑ์", links: ["GPS Tracking", "Delivery Tracking", "Vehicle Leasing", "Partner Program"] },
        { title: "บริษัท", links: ["บทความ", "ร่วมงาน", "ติดต่อเรา"] }
      ],
      rights: "© 2026 Rework Ltd. สงวนลิขสิทธิ์",
      partnerLine: "พาร์ทเนอร์อย่างเป็นทางการของ Verpex, GoDaddy และ Framer"
    },
    services: [
      { icon: "layers", title: "Digital Transformation & System Integration", body: "โซลูชันซอฟต์แวร์ turnkey ที่พาองค์กรของคุณก้าวสู่อนาคต", gain: "ลดเครื่องมือที่ไม่เชื่อมกัน" },
      { icon: "palette", title: "Customer Experience Design & Branding", body: "UX ที่ยึดลูกค้าเป็นศูนย์กลาง การบริการ และ CRM ที่สร้างความภักดี", gain: "ลูกค้าอยู่กับเรานานขึ้น" },
      { icon: "smartphone", title: "Mobile / Web App Development & Marketing", body: "แอปที่สร้างสรรค์และใช้งานง่าย ปรับให้ตรงกับความต้องการของคุณ", gain: "เปิดตัวได้เร็วขึ้น" },
      { icon: "radio-tower", title: "IoT & Location-Based Platforms", body: "โซลูชันที่เชื่อมต่อและชาญฉลาดด้วย IoT และเทคโนโลยีระบุตำแหน่ง", gain: "เห็นข้อมูลแบบเรียลไทม์" }
    ],
    products: [
      { title: "แพลตฟอร์ม GPS Tracking", category: "Fleet visibility", description: "ติดตามรถ อุปกรณ์ เส้นทาง และสถานะงานด้วยแพลตฟอร์มสำหรับทีมโลจิสติกส์", icon: "satellite" },
      { title: "Logistics & Delivery Tracking", category: "Delivery operations", description: "จัดการงานขนส่ง อัปเดตเส้นทาง หลักฐานการส่ง และการมองเห็นสถานะสำหรับลูกค้า", icon: "truck" },
      { title: "Vehicle Leasing Control", category: "Asset control", description: "ดูแลการใช้งานรถ การติดตาม และกฎธุรกิจสำหรับงานเช่ารถและ fleet management", icon: "key-round" },
      { title: "Personal, Pet & Agriculture", category: "Specialized tracking", description: "ปรับใช้ GPS และ IoT สำหรับคน สัตว์เลี้ยง ทรัพย์สินเกษตร และงานภาคสนาม", icon: "map-pinned" },
      { title: "GPS Partner Program", category: "Partner growth", description: "เริ่มรายได้ใหม่ด้วยเทคโนโลยี GPS ของ Rework พร้อม training และ partner support", icon: "handshake" },
      { title: "ราคาและแพ็กเกจ", category: "Commercial options", description: "ดูแนวทางแพ็กเกจและการเริ่มต้นใช้งาน GPS และ telematics", icon: "tag" }
    ]
  }
};

export const supportedLocales = ["en", "th"];
